import { PaginaCrud } from '../components/PaginaCrud'
import type { Ubicacion } from '../types'

export default function Ubicaciones() {
  return (
    <PaginaCrud<Ubicacion>
      titulo="Ubicaciones"
      recurso="ubicaciones"
      llave="id"
      columnas={[
        { campo: 'codigo', titulo: 'Codigo' },
        { campo: 'almacenId', titulo: 'Almacen ID' },
        { campo: 'pasillo', titulo: 'Pasillo', render: (u) => u.pasillo || '-' },
        { campo: 'rack', titulo: 'Rack', render: (u) => u.rack || '-' },
        { campo: 'bin', titulo: 'Bin', render: (u) => u.bin || '-' },
        { campo: 'capacidad', titulo: 'Capacidad', render: (u) => (u.capacidad != null ? u.capacidad : '-') },
        { campo: 'activo', titulo: 'Activo', render: (u) => (u.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'almacenId', etiqueta: 'Almacen ID', tipo: 'numero', requerido: true },
        { nombre: 'codigo', etiqueta: 'Codigo', tipo: 'texto', requerido: true },
        { nombre: 'pasillo', etiqueta: 'Pasillo', tipo: 'texto' },
        { nombre: 'rack', etiqueta: 'Rack', tipo: 'texto' },
        { nombre: 'bin', etiqueta: 'Bin', tipo: 'texto' },
        { nombre: 'capacidad', etiqueta: 'Capacidad', tipo: 'decimal' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
